<template>
    <div class="coverdetailsbloc">
        <span class="info-title">{{$t('Cover.ShowCover.COVER_DETAILS_TITLE')}}</span>
        <div class="divider">
            <v-divider></v-divider>
        </div>
         <div class="coverdetailsbloccontent">
            <v-layout row class="detailfieldinfo">
               <v-flex xs6>
                  <v-label>{{$t('Cover.ShowCover.COVER_NUMBER_FIELD_NAME')}} : </v-label>
               </v-flex>
               <v-flex xs6>
                  {{cover.details.id}}
               </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo">
               <v-flex xs6>
                  <v-label>{{$t('Cover.ShowCover.DURATION_FIELD_NAME')}} : </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.details.duration}} days
               </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo">
               <v-flex xs6>
                  <v-label>{{$t('Cover.ShowCover.QUOTED_AT_FIELD_NAME')}} : </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.details.quotedAt}}
               </v-flex>
            </v-layout>
            <v-layout v-if="cover.invoice.status.toUpperCase() === 'Activated'.toUpperCase()" row class="detailfieldinfo">
               <v-flex xs6>
                  <v-label>{{$t('Cover.ShowCover.ACTIVATED_AT_FIELD_NAME')}} : </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.details.activatedAt}}
               </v-flex>
            </v-layout>
            <v-layout v-if="cover.invoice.status.toUpperCase() === 'Settled'.toUpperCase()" row class="detailfieldinfo">
               <v-flex xs6>
                  <v-label>Settled at : </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.details.settledAt}}
               </v-flex>
            </v-layout>
            <v-flex v-if="!!cover.details.totalCoverPrice">
               <v-layout row class="detailfieldinfo" >
                  <v-flex xs6>
                     <v-label>{{$t('Cover.ShowCover.TOTAL_COVER_PRICE_FIELD_NAME')}} : </v-label>
                  </v-flex>
                  <v-flex xs6>
                     {{cover.details.totalCoverPrice}}
                  </v-flex>
               </v-layout>
               <v-layout row class="detailfieldinfo">
                  <v-flex xs6>

                  </v-flex>
                  <v-flex xs6>
                        <div v-if="showPriceDetails" v-on:click='enablePriceDetails'> <a>{{$t('Cover.ShowCover.SHOW_PRICE_DETAILS_LINK')}} </a> <span class="icon-chevron-down right"></span></div>
                        <div v-if="!showPriceDetails" v-on:click='disablePriceDetails'> <a >{{$t('Cover.ShowCover.HIDE_PRICE_DETAILS_LINK')}}</a> <span class="icon-chevron-up right"></span> </div>
                  </v-flex>
               </v-layout>
               <CoverPriceDetails v-if="!showPriceDetails"/>
            </v-flex>

         </div>
    </div>
</template>
<script>
import CoverPriceDetails from '@/components/cover/details/CoverPriceDetails'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      showPriceDetails: true
    }
  },
  methods: {
    enablePriceDetails () {
      this.showPriceDetails = false
    },
    disablePriceDetails () {
      this.showPriceDetails = true
    }
  },
  computed: {
    ...mapState('cover', ['cover'])
  },
  components: {
    CoverPriceDetails
  }
}
</script>
<style>
.slide-fade-price-enter-active {
  transition: all 1s ease;
}
.slide-fade-price-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-price-enter, .slide-fade-price-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.chevron{
   width: 24px;
   height: 25.3px;
}
</style>
